import { Alert, Box, Grid, IconButton, Link } from '@mui/material'
import { type ReferralData } from '../../Pages/Referral/ReferralDetail'
import { FormatCurrency } from '../../core/Utilities'
import EditIcon from '@mui/icons-material/Edit'
import { SelectProgramModal } from './SelectProgramModal'
import { useState } from 'react'
import { type lookup } from '../../core/types'

export interface ReferralHeaderProps {
  referral: ReferralData
  hideEditButtons: boolean
  onEditHouseholdMembers: (show: boolean) => void
  onEdit: (show: boolean) => void
  onRefresh: () => void
}

export function ReferralHeader (props: ReferralHeaderProps): JSX.Element {
  const [isProgramModalOpen, setIsProgramModalOpen] = useState(false)

  const handleConfirm = async (selectedProgram: lookup): Promise<void> => {
    props.referral.programId = selectedProgram.id
    props.referral.programName = selectedProgram.name
    setIsProgramModalOpen(false)
    props.onRefresh()
  }

  return <>
    <Grid container columns={2} spacing={2} sx={{ paddingTop: '10px' }}>
      <Grid container item spacing={1} xs={6}>
        <Box className={props.referral.documentsSubmittedAndVerified == null || props.referral.documentsSubmittedAndVerified ? 'valid-status' : 'error-status'}>
          {props.referral.documentsSubmittedAndVerified == null ? 'No Documents Required' : (props.referral.documentsSubmittedAndVerified ? 'Documents are Verified' : 'Missing / Unverified Documents')}
        </Box>
      </Grid>
      <Grid item container spacing={1} xs={5} sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box className='valid-status'>
          {props.referral.sessionBlockName}
        </Box>
      </Grid>
      <Grid item container xs={1} sx={{ pt: '0px !important' }}>
        {!props.hideEditButtons && (
          <Box><IconButton data-testid='referralEditButton' onClick={() => { props.onEdit(true) }}><EditIcon /></IconButton></Box>
        )}
      </Grid>
    </Grid>

    <Grid container columns={2} spacing={2} sx={{ paddingTop: '10px' }}>
      {props.referral.incomeApproved !== 'NotApplicable' && <Grid container item spacing={1} xs={6}>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} data-testid='statedIncome'>
          <Box>Stated Income</Box>
          <Box sx={{ fontWeight: 'bold' }}>{FormatCurrency(props.referral.statedIncome)}</Box>
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} data-testid='members'>
          <Box>Household Members</Box>
          <Box sx={{ fontWeight: 'bold' }}>{props.referral.householdMemberCount}
            {!props.hideEditButtons &&
              <IconButton size='small' data-testid='memberCountButton' onClick={() => { props.onEditHouseholdMembers(true) }}><EditIcon fontSize='inherit' /></IconButton>
            }
          </Box>
        </Grid>
        <Grid item xs={12}><hr style={{ margin: '0' }} /></Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} data-testid='verifiedIncome'>
          <Box>Verified Income</Box>
          <Box sx={{ fontWeight: 'bold' }}>{FormatCurrency(props.referral.verifiedIncome)}</Box>
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} data-testid='povertyLevel'>
          <Box>Poverty Level</Box>
          <Box sx={{ color: 'lightseagreen' }}>{props.referral.povertyPercent}{props.referral.povertyPercent !== null ? '%' : ''}</Box>
        </Grid>
      </Grid>
      }
      <Grid item container spacing={1} xs={5} sx={{ display: 'flex', flexDirection: 'column' }}>
        {props.referral.desiredSchedule !== null && <Grid item sx={{ color: 'lightseagreen' }}>{props.referral.desiredSchedule} Schedule Desired</Grid>}
        {props.referral.timePeriodDisplay !== null && <Grid item>{props.referral.timePeriodDisplay}</Grid>}
        {props.referral.facilityName !== null && <Grid item>{props.referral.facilityName}</Grid>}
        <Grid item>{props.referral.programName ??
          (<>Program Missing - <Link sx={{ cursor: 'pointer', textDecoration: 'none' }} onClick={() => { setIsProgramModalOpen(true) }}>Select Here</Link></>)}</Grid>
      </Grid>
    </Grid>
    {props.referral.incomeApproved !== 'NotApplicable' && props.referral.statedIncome !== props.referral.verifiedIncome &&
      <Box sx={{ p: '10px 0 3px 0' }}>
        <Alert severity="warning" sx={{ border: 1, borderColor: 'orange' }}>
          Stated Income and Verified Income do not match. Please make sure income is correct before accepting.
        </Alert>
      </Box>
    }

    {isProgramModalOpen && <SelectProgramModal
      open={isProgramModalOpen}
      onClose={() => { setIsProgramModalOpen(false) }}
      onConfirm={handleConfirm}
      referralId={props.referral.id}
      isdServiceProviderId={props.referral.isdServiceProviderID}
    />}
  </>
}
